import {MENUS} from "../menu";

export const ROUTER_NAMES = {
    CONTATO: 'Responsáveis por Empresa'
}

export default [
    {
        name: ROUTER_NAMES.CONTATO,
        path: '/contato',
        meta: {
            menu: MENUS.SISTEMA,
            searchAlias: 'Contato',
            searchDescription: 'Veja todas os Responsáveis cadastrados',
            searchTerms: ['contatos','Responsáveis','Responsável'],
            hasRole: 'role/contato'
        },
        component: () => import('@/views/Contato')
    },
]